export default __webpack_public_path__ + "static/media/logo.a43a23a7.png";